import type { CostView, CostViewLibraryEntry } from 'types/costViews';
import { createDialogWithIdStore } from '../createDialogWithIdStore';

export const useDeleteViewDialog = createDialogWithIdStore<CostView | CostViewLibraryEntry>();
